module.exports = __webpack_public_path__ + "static/img/project03.45272ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/project03.jpg
// module id = cmkQ
// module chunks = 1